import React, { Component } from 'react';
import img_logo_color from '../../../assets/images/Logo-color.svg';
import img_logo_en_color from '../../../assets/images/logo-color-en.svg';
import img_logo_contrast from '../../../assets/images/Logo.svg';
import img_logo_en_contrast from '../../../assets/images/Logo_EN.svg';
import {Link} from 'react-router-dom';


export default class Middle extends Component{

	constructor(props){
		super(props);

		this.state = {
			data: props.data,
			config: props.config
		}

	}



	render(){
		const logo = () => {
			const contrast = localStorage.getItem('contrast')
			const isAng = window.location.href.indexOf("/en/") > -1
			if(contrast === "down") {
				return  isAng ? img_logo_en_color : img_logo_color
			} else if(contrast === "up") {
				return  isAng ? img_logo_en_contrast : img_logo_contrast
			} else {
				return  isAng ? img_logo_en_color : img_logo_color
			}
		}

		var list = this.state.data;

		var arrayList = [];

		Object.keys(this.state.data).map(function(key,value) {

			arrayList.push(list[key]);
			return 0;

		});

		return (
			<section className="footer_middle">
				<div className="container">
					<div className="row footer-extend">
						<div className="col-xs-6 col-sm-2 col-md-2 col-lg-2 text-center">
							<img className="img-responsive gb-img-logocust-footer" src={logo()} alt="" />
						</div>
						<div className="col-xs-6 col-sm-10 col-md-10 col-lg-10 text-center">
						{Object.keys(this.state.data).map(function(key,value) {

								return (
									<div className="" id={"footerItem-"+key} key={key}>
										<div className="gb-footer-menu text-center">
											<div className="footer-infoblock">
													{Object.keys(arrayList[value]).map(function(key1,value1) {

														if(key1 === "name"){
															return (
																<p className="fr-inf-title" key={value1}>
																	{arrayList[value].name}
																</p>
															);

														}
														return null;
													})}

												<ul className="fr-inflsholder list-footer-middle">
													{Object.keys(arrayList[value]).map(function(key1,value1) {

														if(key1 !== "name"){

															return (<li className="fr-inflitem" key={value1}><a href={arrayList[value][key1].url} target="_blank" className="fr-influnit">{arrayList[value][key1].name}</a></li>);

														}
														return null;
													})}
												</ul>
											</div>
										</div>
									</div>

								);
						})}

					</div>
					</div>
				</div>
			</section>

		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Footer/Middle/index.js